import React from 'react';
import PropTypes from 'prop-types';
import ZendeskInfo from 'components/TicketHandlingPractice/Zendesk/ZendeskInfo';

const TicketHandling = props => {
  const { questionData, answer, answerText } = props;
  if (questionData.requester) {
    return (
      <>
        <div className="bg-white p-16 border border-gray-lighter bdrs-base border-bottom-0 mt-32" />
        <div className="ZendeskPracticeQuestion d-f fd-c ai-c">
          <ZendeskInfo
            data={questionData}
            isViewAnswer
            answer={answer}
            isDisabled
          />
        </div>
        <div className="bg-white p-16 border border-gray-lighter bdrs-base border-top-0" />
      </>
    );
  }
  return (
    <>
      <div className="bdrs-base bg-white p-24 mt-24 mb-24 bs-2">
        <div className="fz-14 fw-b">{questionData.subject}</div>
        <div className="fz-12 mb-32">
          {`${t('questions.question.email_reply.time_stamp')} -
          ${t('questions.question.ticket_handling.creation_type')}`}
        </div>
        <div className="fz-16 ws-pl">{questionData.body}</div>
      </div>
      <span className="fw-b mt-24 fz-16">
        {t('questions.question.response')}
      </span>
      <div className="Card bg-white p-32 mt-24">
        <span className="fz-16 fs-i border-left-solid border-left-1 border-gray pl-16">
          {answerText}
        </span>
      </div>
    </>
  );
};

TicketHandling.propTypes = {
  answerText: PropTypes.string,
  questionData: PropTypes.shape({
    body: PropTypes.string,
    from: PropTypes.string,
    subject: PropTypes.string,
  }),
  answer: PropTypes.shape({
    id: PropTypes.number,
    created_at: PropTypes.string,
  }),
};

export default TicketHandling;
